<a href="javascript:void(0)" mat-icon-button [matMenuTriggerFor]="menu"><i class="icon-more-vert"></i></a>
        <mat-menu #menu="matMenu" class="mpc_logout_txt">
            <!-- <button mat-menu-item (click)="Show_chng_pwd()">
                <span>Change Password</span>
            </button> -->
            <ul>
                <li mat-menu-item  [routerLink]="['/user/profile']" class="mplt_adm_card" >
                   <img src="assets/images/default/girl.jpg" alt=""> 
                   <p>{{parent_det.parent_info.name}} <span>Parent</span></p>
                </li>

                <!-- <li mat-menu-item  [routerLink]="['/user/profile']" class="mplt_sub_adm_card" >
                    
                    <div>

                        <img src="assets/images/default/girl.jpg" alt=""> 
                        <p>Diya <span>L Dot</span></p>

                    </div>

                    <div>

                        <img src="assets/images/default/girl.jpg" alt=""> 
                        <p>Diya <span>L Dot</span></p>

                    </div>

                 </li> -->

                <!-- <li mat-menu-item  [routerLink]="['/user/profile']">
                    Profile
                 </li> -->
           
                <li mat-menu-item (click)="Logout()">
                    Logout
                </li>
            </ul>
        </mat-menu>